var UI = UI || { };

UI.Menu = {
    init: function() {
        var header = document.getElementsByClassName('header')[0];
        var toggler = document.getElementsByClassName('header__nav-toggle')[0];
        toggler.addEventListener('click', function(e) {
            e.preventDefault();
            header.classList.toggle('header--open');
        })
    }
}

UI.floatable = {
    init: function() {
        var inputs = document.getElementsByClassName('input--floatable');
        for (var i = 0; i < inputs.length; i++) {
            inputs[i].addEventListener('blur', function (event) {
                UI.floatable.check(event.target);
            });
            UI.floatable.check(inputs[i]);
        }
    },
    check: function(el) {
        var isFilled = el.value !== ''
        if (isFilled) {
            el.classList.add('filled')
        } else {
            el.classList.remove('filled')
        }
    }
}

UI.init = function() {
    window.onload = function () {
        UI.floatable.init();
        UI.Menu.init();
    }
}

export default UI;



// WEBPACK FOOTER //
// ./src/ui.js